import { get, post, put, destroy } from "./base";

const ProductOptionServ = {
  index: (params) => get('/product-options', { params }),
  single: (id) => get(`/product-options/${id}`),
  create: (payload) => post('/product-options', payload),
  update: (id, payload) => put(`/product-options/${id}`, payload),
  remove: (id) => destroy(`/product-options/${id}`),
};

export default ProductOptionServ;


